<template>
  <v-container> <!-- vuetify -->
    <v-breadcrumbs :items="crumbs" large>
    </v-breadcrumbs><!-- vuetify -->
    <div class="grey lighten-5">
      <div class="grid grid-cols-8">
        <div class="col-span-3">
          <v-card class="pa-2" :class="$style.identity" outlined tile> <!-- vuetify -->
            <div class="flex items-center w-full mt-1 px-4 py-3 leading-5">
              <span class="text-sm text-gray-600">Name</span>
            </div>
            <div class="w-full flex ml-4" v-for="(name, index) in patient.name" :key="index">
              <div class="flex-none w-20 pt-4 px-1">
                <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
                  Prefix
                </label>
                <dropdown v-model="name.prefix" :options="['Dr', 'Miss', 'Mr', 'Mrs', 'Ms', 'Prof']"></dropdown>
              </div>
              <v-flex xs5 sm5 md4> <!-- vuetify -->
                <v-text-field
                  v-model="name.given"
                  label="Given names"
                  required
                ></v-text-field> <!-- vuetify -->
              </v-flex>
              <v-flex xs5 sm5 md5> <!-- vuetify -->
                <v-text-field
                  v-model="name.family"
                  label="Family name"
                  required
                ></v-text-field><!-- vuetify -->
               </v-flex>
            </div>
          </v-card>
        </div>
        <div class="col-span-3">
          <v-card class="pa-2" :class="$style.identity" outlined tile><!-- vuetify -->
            <div class="flex items-center w-full mt-1 px-4 py-3 leading-5">
              <span class="text-sm text-gray-600">Demographics</span>
            </div>
            <div class="w-full flex ml-4">
              <div class="flex flex-col w-1/3 pt-4"><!-- vuetify -->
                <!-- <v-text-field
                  v-model="patient.birthDate"
                  label="Birthdate"
                ></v-text-field> -->
                <text-field :value="patient.birthDate | localeDate" label="Birthdate" @input="patient.birthDate = isoDate($event)" >
                </text-field>
                <span class="text-gray-500 -mt-3 ml-1 text-xs">dd/mm/yyyy</span>
              </div>
              <div class="flex-none w-24 pt-4 ml-4">
                <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
                  Gender
                </label>
                <dropdown v-model="patient.gender" :options="['male', 'female', 'other']"></dropdown>
              </div>
              <div class="flex-none w-1/3 pt-4 ml-4">
                <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
                  Deceased status
                </label>
                <toggle-switch class="mt-2" display-text :off-text='"alive"' :on-text='"deceased"' v-model="patient.deceased.deceasedBoolean">
                </toggle-switch>
              </div>
            </div>
          </v-card>
        </div>
        <div class="col-span-2">
          <v-card class="pa-2" outlined tile><!-- vuetify -->
          <div class="flex items-center w-full mt-1 px-4 py-3 leading-5">
            <span class="text-sm text-gray-600">Photo</span>
          </div>
            <img @click="qrDialog = true" alt="Take photo button" src="../assets/phone-photo.png">
          </v-card>
        </div>
      </div>

    </div>
    <div class="tab-body">
      <v-tabs
        v-model="tab"
        class="elevation-2"
        :centered="centered"
        :grow="grow"
        :vertical="vertical"
        :right="right"
        :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
        :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
        :icons-and-text="icons"
      > <!-- vuetify -->
        <v-tabs-slider></v-tabs-slider>
        <v-tab :href="`#tab-identity`"
        >
          Identity
          <v-icon v-if="icons">mdi-phone</v-icon> <!-- vuetify -->
        </v-tab>
        <v-tab :href="`#tab-contact`"
        >
          Communication details
          <v-icon v-if="icons">mdi-phone</v-icon> <!-- vuetify -->
        </v-tab>
        <v-tab :href="`#tab-enrollment`"
        >
          Study enrollment
          <v-icon v-if="icons">mdi-phone</v-icon> <!-- vuetify -->
        </v-tab>
        <v-tab-item :value="'tab-identity'">
          <div class="flex items-center w-full mt-1 px-4 py-3 leading-5">
            <span class="text-sm text-gray-600">Hospital/Clinic identifiers</span>
          </div>
          <div v-for="(id, index) in patient.identifier" :key="index" class="bg-gray-50 px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"><!-- vuetify -->
            <div class="flex-initial w-auto pt-4 mx-6">
              <label class="-mt-4 absolute block text-xs font-medium text-gray-600">
                Assigner
              </label>
              <dropdown v-model="id.assigner" :options="idAssigners"></dropdown>
            </div>
            <v-flex xs4 sm3 md3> <!-- vuetify -->
              <v-text-field
                v-model="id.value"
                label="ID Number"
                required
              ></v-text-field> <!-- vuetify -->
            </v-flex>
          </div>
        </v-tab-item>
        <v-tab-item value="tab-contact">
          <div class="w-full flex ml-4">
            <div class="flex-initial w-auto pt-4 ml-1">
              <label class="block mt-2 text-sm text-gray-700">
                Preferred Language:
              </label>
            </div>
            <div class="flex-initial w-auto pt-4 mx-2">
              <dropdown v-model="patient.communication.language" :options="languagesValueList"></dropdown>
            </div>
          </div>
          <div class="flex items-center w-full mt-1 px-4 py-3 leading-5">
            <span class="text-sm text-gray-600">Telecommunications</span>
          </div>
          <div class="comms-wrapper">
            <div class="telecoms-wrapper">
              <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                v-for="(telecom, index) in patient.telecom"
                :key="index">
                <v-flex d-flex offset-sm-1>
                  <telecom-editor :telecom="telecom" @systemChanged="onTelecomSysChange"></telecom-editor>
                </v-flex>
                <v-flex xs2 sm1 md1>
                  <div class="end-button">
                    <v-btn color="grey" small icon dark @click="deleteTelecom(index)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
              </div>
              <v-btn small @click="addTelecom">Add telecommunication details</v-btn>
            </div>
            <div class="preferred-wrapper">
              <!-- <v-select
                :items="getCommsMethods"
                :item-text="system"
                :item-value="system"
                v-model="getPreferredMethod"
                label="Preferred method of contact"
                dense
                @change="onPreferredChange"
              ></v-select> -->
              <span v-if="patient.telecom" class="theme--light v-label top-label">Active?</span>
              <div class="method-activators">
                <v-checkbox
                  v-for="(tel, index) in patient.telecom"
                  :key="index"
                  v-model="tel.use"
                  :label="`${tel.system} - ${tel.value}`"
                  @change="onMethodToggle(tel.system, index, tel.use)">
                </v-checkbox>
                <v-checkbox
                  v-for="(address, index) in patient.address"
                  :key="index"
                  v-model="address.use"
                  :label="`letter - ${address.line1}`"
                  @change="onMethodToggle('letter', index, address.use)">
                </v-checkbox>
              </div>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item value="tab-enrollment">
          <v-subheader>Study enrollment and consent</v-subheader>
        </v-tab-item>
      </v-tabs>

      <v-btn :disabled="!valid" class="mr-4" @click="savePatient()">
        Save
      </v-btn>

      <v-btn class="mr-4" @click="reset">
        Reset
      </v-btn>
    </div>
    <v-dialog
      v-model="qrDialog"
      width="500"
    >
      <connect-phone v-if="qrDialog" :url="`${getPatientUrl}/photo/qrCode`" ></connect-phone>
      <v-btn color="pink" flat @click="qrDialog = false">Cancel</v-btn>
    </v-dialog>
    <v-snackbar v-model="patientSaveSnackbar" :bottom="true" :left="false" :multi-line="false"
      :right="false" :timeout=6000 :top="false" :vertical="true">
      Patient record saved.
      <button @click="patientSaveSnackbar = false" class="text-gray-100 hover:text-yellow-400 font-medium rounded-sm shadow text-xs uppercase w-8 mt-4 p-2">
        Close
      </button>
    </v-snackbar>
  </v-container>
</template>

<script>
import { DateTime } from 'luxon'
import { languages } from '@/utils/valueLists'
import dayjs from 'dayjs'
import ConnectPhone from '../components/ConnectPhone'
import Dropdown from '@/components/Dropdown.vue'
import TelecomEditor from '@/components/TelecomEditor.vue'
import TextField from '@/components/TextField.vue'
import ToggleSwitch from '@/components/ToggleSwitch.vue'

export default {
  data () {
    return {
      crumbs: [
        { text: 'Patients', disabled: false, href: `/#/${this.$route.params.orgName}/home/` },
        { text: this.$route.params.patientId, disabled: false, href: `/#/${this.$route.params.orgName}/patient/${this.$route.params.patientId}` },
        { text: 'edit', disabled: true, href: `/#/patient/${this.$route.params.patientId}/edit` }
      ],
      idAssigners: ['SVH UR', 'Medicare', 'OAHKS DB', 'Demo UR'],
      languagesValueList: languages,
      patient: {},
      patientSaveSnackbar: false,
      qrDialog: false,
      valid: true
    }
  },
  components: {
    ConnectPhone, Dropdown, TelecomEditor, TextField, ToggleSwitch
  },
  computed: {
    getCommsMethods () {
      if (this.patient.telecom) {
        const methods = this.patient.telecom.filter(tel => tel.use).map(x => x.system)
        if (this.patient.address) {
          if (this.patient.address.some(address => address.use)) {
            methods.push('letter')
          }
        }

        return methods
      } else return []
    },
    getPatientUrl () {
      return `${process.env.VUE_APP_API_BASEURL}/patient/3`
    }
  },
  filters: {
    localeDate: function (val) {
      if (val && dayjs(val).isValid()) return dayjs(val).format('DD/MM/YYYY')
      else return val
    }
  },
  methods: {
    addTelecom () {
      if (!this.patient.telecom) {
        this.$set(this.patient, 'telecom', [])
      }
      this.patient.telecom.push({ system: '', value: '', use: '' })
    },
    deleteTelecom (telIndex) {
      this.patient.telecom.splice(telIndex, 1)
    },
    getPreferredMethod () { // return the address or telecom object where rank = 1
      const combinedAddresses = this.patient.telecom.concat(this.patient.address)
      const preferred = combinedAddresses.find(address => address.rank === 1)
      if (preferred) return preferred.system || 'letter'
      return null
    },
    isoDate (formattedDate) {
      const isoString = dayjs(formattedDate, ["DD/MM/YYYY", "DD/MM/YY"]).toISOString()
      // if formattedDate is empty, save a blank string
      if (!formattedDate) return ''
      return isoString
    },
    onTelecomSysChange (telecom) {
      // if this is the first telecom entry of its kind or a phone, mark as active
      const systemEntries = this.patient.telecom.filter(entry => entry.system === telecom.system)
      if (systemEntries.length === 1 || telecom.system === 'phone') {
        const arrayIndex = this.patient.telecom.findIndex(tel => tel.value === telecom.value)
        this.patient.telecom[arrayIndex].use = true
      }
    },
    async savePatient () {
      // set the API endpoint URL based on whether this is a new or exisitng patient record
      let endpoint = `${process.env.VUE_APP_API_BASEURL}/patient`
      if (this.$route.params.patientId !== 'new') {
        endpoint += `/${this.patient.systemId}`
      }

      const saveResponse = await this.axios.post(endpoint, this.patient, {})
      console.log(`api response: ${saveResponse.status} - ${saveResponse.data}`)
      this.patientSaveSnackbar = true
    }
  },
  async created () {
    if (this.$route.params.patientId !== 'new') {
      const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/patient/${this.$route.params.patientId}`)
      this.patient = results.data
      this.patient.birthDate = DateTime.fromISO(this.patient.birthDate)
    } else {
      this.patient = {
        identifier: [{ use: 'official', value: '', assigner: 'SVH UR' }],
        birthDate: '',
        deceased: {},
        gender: '',
        name: [{ use: '', family: '', given: '', prefix: '', suffix: '' }],
        telecom: [],
        address: [],
        contact: [],
        communication: [],
        managingOrganization: this.$store.state.auth.user.managingOrganization
      }
    }
  }
}
</script>

<style module>
.identity {
  height: 210px;
}
</style>
